import { s3UtilityService } from "./S3Utilities"; 

export const S3StagingManager = {
    stageUpdate: (item, stagedChanges, userInput, existingKey = null) => {
        if (userInput === null) return stagedChanges;

        const labelValue = userInput.trim();
        const currentTags = stagedChanges[item.path]?.tags || { ...item.tags };
        const updatedTags = { ...currentTags };

        // 🎯 FIX: OVERWRITE & DELETE LOGIC
        if (labelValue === "" || labelValue.toLowerCase() === "delete") {
            // If editing an existing one and clearing it, remove it
            if (existingKey) delete updatedTags[existingKey];
        } else {
            // If we were editing an old key, remove the old version first
            if (existingKey && existingKey !== labelValue) {
                delete updatedTags[existingKey];
            }
            // Add the new label (Value is the Key for UserDefined labels)
            updatedTags[labelValue] = "Label"; 
        }

        return {
            ...stagedChanges,
            [item.path]: { tags: updatedTags, filename: item.filename }
        };
    },

    commitChanges: async (targetBucket, config, stagedChanges, onProgress) => {
        const paths = Object.keys(stagedChanges);
        for (let i = 0; i < paths.length; i++) {
            const path = paths[i];
            const tags = stagedChanges[path].tags;
            if (onProgress) onProgress(i + 1, paths.length, path);
            await s3UtilityService.updateTags(targetBucket, config, path, tags);
        }
    }
};